import { ReactNode } from 'react';

interface SwitchProps {
  handleOnClick: () => void;
  name: string;
  id: string;
  htmlFor: string;
  label: ReactNode;
  checked: boolean;
  containerClass?: string;
  required?: boolean;
}

function Switch({ handleOnClick, name, id, htmlFor, label, checked, containerClass, required }: SwitchProps) {
  return (
    <div className={`input checkbox-label form-check form-switch ${containerClass}`}>
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        name={name}
        id={id}
        onChange={handleOnClick}
        checked={checked}
      />
      <label htmlFor={htmlFor}>
        {label}
        {required && <span className="required-asterisk"> *</span>}
      </label>
    </div>
  );
}

export default Switch;
